import { SunburstChartProps } from "./components/SunBurstChart";
import { EvolutionChartProps } from "./components/EvolutionChart";
import { TextCardContentProps } from "./components/TextCardContent";
import { TreeChartProps } from "./components/TreeChart";
import { WeatherInfoCardContentProps } from "./components/WeatherInfoCardContent";
import { AccumulatedCertifiedEnergyProps } from "./components/metas/AccumulatedCertifiedEnergyChart";
import { AccumulatedEnergyProps } from "./components/metas/AccumulatedEnergyChart";
import { LossDiagramProps } from "./components/metas/LossDiagramChart";
import { ProductivityProps } from "./components/metas/ProductivityChart";
import { ParetoChartProps } from "./components/ParetoChart";
import { TrackerChartProps } from "./components/TrackerChart";
import { HeatmapChartProps } from "./components/HeatmapChart";

export enum CardIntervalOptionsEnum {
  Dia = 1,
  Mes,
  Ano,
}

export type GetRopCardParams = {
  usinaId: number; //ropInputId
  interval: CardIntervalOptionsEnum;
  date: string | Date;
  ropCardType: number;
};

export type ItemLayoutsConfig = {
  id: string;
  layouts: {
    lg?: ItemLayoutConfig[];
    md?: ItemLayoutConfig[];
    sm?: ItemLayoutConfig[];
    xs?: ItemLayoutConfig[];
    xxs?: ItemLayoutConfig[];
  };
};
export type ItemLayoutConfig = {
  cardId: string;
  x: number;
  y: number;
  w: number;
  h: number;
  minW?: number;
  maxW?: number;
  minH?: number;
  maxH?: number;
  moved?: boolean;
  static?: boolean;
  isDraggable?: boolean;
  isResizable?: boolean;
  resizeHandles?: ResizeHandle[];
  isBounded?: boolean;
};
export type CardLayouts = {
  lg: ItemLayoutConfig;
  md: ItemLayoutConfig;
  sm: ItemLayoutConfig;
  xs: ItemLayoutConfig;
  xxs: ItemLayoutConfig;
};
type ResizeHandle = "s" | "w" | "e" | "n" | "sw" | "nw" | "se" | "ne";

export type CardInfo = {
  id: string;
  childrenType: ChildrenTypeEnum;
  childrenProps: CardChildrenProps;
  type: CardTypesEnum;
};
export type CardInfoIdentifiers = {
  id: string;
  type: CardTypesEnum;
};

export type CardChildrenProps =
  | EvolutionChartProps
  | TreeChartProps
  | SunburstChartProps
  | TextCardContentProps
  | WeatherInfoCardContentProps
  | AccumulatedEnergyProps
  | LossDiagramProps
  | AccumulatedCertifiedEnergyProps
  | ProductivityProps
  | ParetoChartProps
  | TrackerChartProps
  | HeatmapChartProps;

export enum ChildrenTypeEnum {
  TextCard = 1,
  EvolutionChart,
  SunburstChart,
  TreeChart,
  WeatherCard,
  AccumulatedEnergyChart,
  LossDiagramChart,
  AccumulatedCertifiedEnergyChart,
  ProductivityChart,
  ParetoChart,
  TrackerChart,
  HeatmapChart,
}
export type DateAndValue = {
  dateTime: string;
  value: number;
};
export enum CardTypesEnum {
  PRRealizado = 1,
  PerformanceRatio = 2,
  EnergiaGerada = 3,
  ValorGerado = 4,
  Disponibilidade = 5,
  Ambiente = 6,
  EvolucaoGeracao = 7,
  GeracaoPlanta = 8,
  EnergiaAcumulada = 9,
  DiagramaPerdas = 10,
  EnergiaAcumEnergiaCert = 11,
  Produtividade = 12,
  Pareto = 15,
  TensaoDeLinha = 17,
  Tracker = 18,
  Heatmap = 19,
  PotenciaAtiva = 20,
  EnergiaAcumuladaMWh = 21
}

export type CardsDisplayableProps = {
  id: string;
  prRealizado: {
    title: boolean;
    value: boolean;
  };
  tensaoDeLinha: {
    title: boolean;
    tensaoDeLinhakV: boolean;
  };
  performanceRatio: {
    title: boolean;
    value: boolean;
    idealEnergy: boolean;
  };
  energiaGerada: {
    title: boolean;
    value: boolean;
    ideal: boolean;
    percent: boolean;
  };
  valorGerado: {
    title: boolean;
    value: boolean;
    ideal: boolean;
    percent: boolean;
  };
  disponibilidade: {
    title: boolean;
    value: boolean;
  };
  ambiente: {
    wearher: boolean;
  };
  evolucaoGeracao: {
    title: boolean;
  };
  geracaoPlanta: {
    title: boolean;
  };
  energiaAcumulada: {
    title: boolean;
  };
  diagramaPerdas: {
    title: boolean;
  };
  energiaAcumEnergiaCert: {
    title: boolean;
  };
  produtividade: {
    title: boolean;
  };
  pareto: {
    title: boolean;
  };
  tracker: {
    title: boolean;
  };
  heatmap: {
    title: boolean;
  };
  potenciaAtiva: {
    title: boolean;
    value: boolean;
  };
  energiaAcumudalaMWh: {
    title: boolean;
    value: boolean;
  };
};

export type CardsDisplayableColorProps = {
  id: string;
  evolucaoGeracao: {
    evolucaoColor: string;
    irradianciaColor: string;
  };
  geracaoPlanta: {
    inversorColor: string;
    plantaColor: string;
    potenciaAtivaColor: string;
    ugColor: string;
  };
  energiaAcumulada: {
    energiaIdealColor: string;
    energiaGeradaColor: string;
    P50Color: string;
  };
  diagramaPerdas: {
    energiaColor: string;
    perdaColor: string;
  };
  energiaAcumEnergiaCert: {
    energiaGeradaColor: string;
    P50Color: string;
    P75Color: string;
    P90Color: string;
    P95Color: string;
  };
  produtividade: {
    energiaGeradaColor: string;
    energiaPrevistaColor: string;
    irradianciaColor: string;
    irradianciaPrevistaColor: string;
  };
  pareto: {
    enventosQntdColor: string;
    porcentagemColor: string;
  };
  tracker: {
    esperadoColor: string;
    trackersColor: string;
  };
  heatmap: {
    maxColor: string;
    minColor: string;
  };
};
export type EquipmentFilter = {
  ugName?: string;
  inversorName?: string;
};

export type Recurso = {
  name: string,
  type: string,
  uri: string,
  isEnabled: boolean
  requires2FactorAuthentication: boolean
}
